// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"ImagePreviewDialog_dialogWrapper__iCXb4","closeBtn":"ImagePreviewDialog_closeBtn__1qgdv","image":"ImagePreviewDialog_image__3b4ps"};